document.addEventListener('scroll', function() {
    var scrollThreshold = 20; // Set the scroll threshold
    var stickyPageheader = document.getElementById('shopify-section-sections--23054563148096__header');
    var isSticky = window.scrollY > scrollThreshold;
    if(stickyPageheader) {
      if (isSticky) {
          stickyPageheader.classList.add('scrolled');
      } else {
          stickyPageheader.classList.remove('scrolled');
      }      
    }
});

document.addEventListener('DOMContentLoaded', function() {
  const btn    = document.querySelector('.smooth-read-more');
  const target = document.getElementById('smooth-desc');
  const header = document.querySelector('.section-header'); // or your header selector

  if (!btn || !target || !header) return;

  btn.addEventListener('click', function(e) {
    e.preventDefault();
    // how tall is the header?
    const headerHeight = header.offsetHeight;
    // where is #smooth-desc relative to the document top?
    const targetY = target.getBoundingClientRect().top + window.pageYOffset;
    // scroll to just above it
    window.scrollTo({
      top: targetY - headerHeight,
      behavior: 'smooth'
    });
  });
});

let countdownInterval;

function initializeCountdown() {
  const countdownEl = document.getElementById('ordr-countdown');
  if (!countdownEl) return;

  // Clear any previous interval to avoid stacking
  if (countdownInterval) clearInterval(countdownInterval);

  function updateCountdown() {
    const now = new Date();
    const noon = new Date();
    noon.setHours(12, 0, 0, 0);
    if (now > noon) noon.setDate(noon.getDate() + 1);

    const diff = noon - now;

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    countdownEl.textContent = `${hours}hr${hours !== 1 ? 's' : ''} ${minutes}min${minutes !== 1 ? 's' : ''} ${seconds}s`;
  }

  updateCountdown(); // Initial call
  countdownInterval = setInterval(updateCountdown, 1000); // Update every second
}

// Initial load
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(initializeCountdown, 1500);
});

// Re-run on variant change
document.addEventListener('change', function (e) {
  if (e.target.name === 'id') {
    setTimeout(initializeCountdown, 800);
  }
});

//REMOVE GBP
document.addEventListener("DOMContentLoaded", function () {
  const moneyElements = document.querySelectorAll(".money");

  function removeGBP(el) {
    if (el && el.textContent.includes("GBP")) {
      el.textContent = el.textContent.replace(/\s*GBP\s*/g, "");
    }
  }

  // Initial check
  moneyElements.forEach(removeGBP);

  // Watch for dynamic changes
  const observer = new MutationObserver(function (mutationsList) {
    for (let mutation of mutationsList) {
      if (mutation.type === "childList" || mutation.type === "characterData") {
        const target = mutation.target.nodeType === 3 ? mutation.target.parentNode : mutation.target;
        if (target.classList && target.classList.contains("money")) {
          removeGBP(target);
        }
      }
    }
  });

  moneyElements.forEach(el => {
    observer.observe(el, { childList: true, characterData: true, subtree: true });
  });
});

document.addEventListener('DOMContentLoaded', function() {
    initializeSticky();
    checkClassRemovalOnScroll();
    var container = document.querySelector('.store-msg-v2 .store-messages-mobile');
    if(!container) {
      return;
    }
    var messages = Array.from(container.querySelector('.container').children);
    var currentIndex = 0;
    var transitionDuration = 1000; // Duration of the fade-in and move-up transition (1s)
    var displayDuration = 3000; // Duration to display each text (3s)
    var offset = 16; // Additional height in pixels

    function updateContainerHeight() {
        var activeMessage = messages[currentIndex];
        var messageHeight = activeMessage.offsetHeight;
        container.style.height = `${messageHeight + offset}px`;
    }

    function showText(index) {
        // Add outgoing class to the current message to fade out and move up
        messages[currentIndex].classList.add('outgoing');

        // Wait until transition is done before showing the new message
        setTimeout(function() {
            // Remove outgoing class and add active class to the new message
            messages[currentIndex].classList.remove('active', 'outgoing');
            messages[index].classList.add('active');

            // Update container height based on the new active message
            updateContainerHeight();

            // Prepare the next index
            currentIndex = index;
        }, transitionDuration); // Ensure this matches the CSS transition duration
    }

    function rollText() {
        // Determine the next index
        var nextIndex = (currentIndex + 1) % messages.length;

        // Show the next message
        showText(nextIndex);

        // Delay before showing the next message
        setTimeout(rollText, displayDuration); // Display each message for `displayDuration`
    }

    // Initialize by showing the first message
    messages[currentIndex].classList.add('active');
    updateContainerHeight(); // Set initial height based on the first message
    rollText();

});

function initializeSticky() {
  const stickyElement = document.querySelector('.boost-sd__toolbar-top-mobile');
  const stickySorting = document.querySelector('.boost-sd__toolbar-item--sorting');
  if (!stickyElement) {
    // Retry if the element is not present yet
    setTimeout(initializeSticky, 500);
    return;
  }

  const stickyOffset = stickyElement.offsetTop;

  function handleScroll() {
    if (window.innerWidth <= 767) { // Apply only on mobile screens
      const rect = stickySorting.getBoundingClientRect();
      if (rect.top <= 0) {
        stickyElement.classList.add('stuck');
      } else {
        stickyElement.classList.remove('stuck');
      }
    } else {
      stickyElement.classList.remove('stuck'); // Reset on larger screens
    }
  }

  // Add the scroll and resize event listeners
  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', handleScroll);
}

function checkClassRemovalOnScroll() {
  const parentElement = document.querySelector('.sticky-atc');
  const smileLauncher = document.querySelector('#smile-ui-lite-launcher-frame-container');

  if (!smileLauncher) {
    // Retry if the parent element is not present yet
    setTimeout(checkClassRemovalOnScroll, 500);
    return;
  }

  if (window.innerWidth <= 767) { // Only run the logic for screens with a max-width of 767px
    // Check if the parent no longer has the .sticky-atc--out class
    if (!parentElement.classList.contains('sticky-atc--out')) {
      smileLauncher.style.setProperty('bottom', '125px', 'important');
    } else {
      smileLauncher.style.setProperty('bottom', '16px', 'important');
    }
  }
  
  function handleScroll() {
    if (window.innerWidth <= 767) { // Only run the logic for screens with a max-width of 767px
      // Check if the parent no longer has the .sticky-atc--out class
      if (!parentElement.classList.contains('sticky-atc--out')) {
        smileLauncher.style.setProperty('bottom', '125px', 'important');
      } else {
        smileLauncher.style.setProperty('bottom', '16px', 'important');
      }
    }
  }

  // Add the scroll event listener
  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', handleScroll); // Ensure it re-checks on resize
}

// Ensure it runs once the DOM is ready
document.addEventListener("DOMContentLoaded", checkClassRemovalOnScroll);


// document.addEventListener('DOMContentLoaded', function() {
  
//   setTimeout(function() {
//     // Select the element with the class 'boost-sd__header-description'
//     var descriptionElement = document.querySelector('.boost-sd__header-description');
//     if(descriptionElement) {
//       console.log('ready');
//     } else {
//       console.log('not ready');
//     }
//   }, 1200);
// });

window.onload = function () {
  setTimeout(function() {
    // Select the parent element with the class '.boost-sd__header-main-2'
    var headerMain = document.querySelector('.boost-sd__header-main-2');
    
    // Check if the element with the class '.boost-sd__header-image' exists
    if (!document.querySelector('.boost-sd__header-image')) {
        // If '.boost-sd__header-image' does not exist, add the 'no-bg' class to the parent
        headerMain.classList.add('no-bg');
    }
  }, 1000);
};

document.addEventListener('DOMContentLoaded', function() {
    var descriptionElement = document.querySelector('.boost-sd__header-description');
    
    if (!descriptionElement) {
        // Use a MutationObserver to listen for dynamically inserted elements
        var observer = new MutationObserver(function(mutations) {
            descriptionElement = document.querySelector('.boost-sd__header-description');
            if (descriptionElement) {
                collectionReadMore(descriptionElement);
                observer.disconnect(); // Stop observing once the element is found
            }
            // console.log('running');
        });

        observer.observe(document.body, { childList: true, subtree: true });
    } else {
        collectionReadMore(descriptionElement);
    }
});


function collectionReadMore(descriptionElement) {
    if(descriptionElement) {
      // Extract the full HTML content
      var fullContent = descriptionElement.innerHTML;
      
      // Set the maximum character limit
      var maxLength = 220;
      
      // Check if the text exceeds the maximum length
      if (descriptionElement.innerText.length > maxLength) {
          // Create a span for the truncated text
          var visibleText = descriptionElement.innerText.substring(0, maxLength);
          var truncatedContent = '<span class="truncated-text">' + visibleText + '...</span>';
          
          // Create a span for the hidden text
          var hiddenContent = '<span class="hidden-text" style="display: none;">' + fullContent + '</span>';
      
          // Create the "Read More" link
          var readMoreLink = document.createElement('a');
          readMoreLink.href = '#'; // Placeholder link
          readMoreLink.innerText = 'Read More';
          readMoreLink.classList.add('read-more-link');
      
          // Set the HTML content with truncated text and Read More link
          descriptionElement.innerHTML = truncatedContent + hiddenContent;
          descriptionElement.appendChild(readMoreLink);
      
          // Add event listener to toggle text visibility when clicking "Read More"
          readMoreLink.addEventListener('click', function (event) {
              event.preventDefault(); // Prevent default anchor behavior
      
              // Toggle visibility of hidden text
              var hiddenTextElement = descriptionElement.querySelector('.hidden-text');
              var truncatedTextElement = descriptionElement.querySelector('.truncated-text');
      
              if (hiddenTextElement.style.display === 'none') {
                  hiddenTextElement.style.display = 'inline';
                  truncatedTextElement.style.display = 'none';
                  readMoreLink.innerText = 'Show Less'; // Change link text to "Show Less"
              } else {
                  hiddenTextElement.style.display = 'none';
                  truncatedTextElement.style.display = 'inline';
                  readMoreLink.innerText = 'Read More'; // Reset link text to "Read More"
              }
          });
      }
    }
}
